/**
 * useAuth Hook
 * Custom hook to access auth context
 */

import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/**
 * Hook to access authentication state and methods
 *
 * @returns {Object} Auth context value
 * @property {Object|null} user - Current user data
 * @property {boolean} loading - Loading state
 * @property {string|null} error - Error message
 * @property {boolean} isAuthenticated - Whether user is logged in
 * @property {Function} login - Login function
 * @property {Function} register - Register function
 * @property {Function} logout - Logout function
 * @property {Function} forgotPassword - Forgot password function
 * @property {Function} resetPassword - Reset password function
 * @property {Function} updateProfile - Update profile function
 * @property {Function} clearError - Clear error function
 */
export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export default useAuth;
